import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('mfg_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('mfg_token');
      window.location.href = '/login';
    }
    if (err.response?.status === 403 && err.response?.data?.code === 'REAUTH_REQUIRED') {
      window.dispatchEvent(new CustomEvent('google-reauth-required'));
    }
    return Promise.reject(err);
  }
);

export default api;
